import React from 'react';
import MiniPlayer from '@/components/GlobalPlayer/MiniPlayer';

const GlobalPlayer: React.FC = () => {
  return <MiniPlayer />;
};

export default GlobalPlayer; 